import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraDivider } from '../ensigns/divider';
import { SpecraLogo } from '../ensigns/logo';
import { SpecraHeading, SpecraText } from '../ensigns/typography';
/** Brand, back affordance, and current-program identity for the sidebar. */ export function SpecraProgramIdentity({ backAction, collapsed = false, programId, programName, toggleControl }) {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: collapsed ? 'flex min-h-12 items-center justify-center px-2' : 'flex min-h-12 items-center px-4',
                children: /*#__PURE__*/ _jsx(SpecraLogo, {
                    variant: collapsed ? 'mark' : 'lockup'
                })
            }),
            toggleControl ? /*#__PURE__*/ _jsx("div", {
                className: "absolute right-0 top-12 z-10 translate-x-1/2",
                children: toggleControl
            }) : null,
            backAction ? /*#__PURE__*/ _jsx("div", {
                className: collapsed ? 'px-2 pt-2 text-center' : 'px-2 pt-2',
                children: backAction
            }) : null,
            /*#__PURE__*/ _jsxs("div", {
                className: "mx-4 mt-3 pb-3",
                children: [
                    /*#__PURE__*/ _jsx(SpecraHeading, {
                        className: collapsed ? 'text-center text-[length:var(--fs-ui-caption)]' : '',
                        size: "sm",
                        children: collapsed ? programName.slice(0, 2).toUpperCase() : programName
                    }),
                    !collapsed && programId ? /*#__PURE__*/ _jsx(SpecraText, {
                        className: "mt-0.5 block truncate tabular-nums",
                        size: "caption",
                        tone: "muted",
                        children: programId
                    }) : null
                ]
            }),
            /*#__PURE__*/ _jsx(SpecraDivider, {})
        ]
    });
}
